export const feedbackStyles = {
	container: 'flex flex-col items-center gap-6 min-w-[288px] w-full py-16',
	iconWrapper: 'flex items-center justify-center w-16 h-16 rounded-full bg-[#ededf5]',
	textBlock: 'flex flex-col items-center gap-2 text-center w-full',
	title: 'text-2xl font-bold text-[#2e2e3a] leading-[1.3] font-[Figtree,sans-serif]',
	description: 'text-base font-normal text-[#6a6977] leading-[1.5] font-[Figtree,sans-serif] max-w-[480px]',
	actionsColumn: 'flex flex-col items-center gap-2'
} as const;
